import React from 'react';

import Airconditioning from '@icons/airconditioning.svg';
import AirportShuttle from '@icons/airport_shuttle.svg';
import Bar from '@icons/bar.svg';
import Beach from '@icons/beach.svg';
import BreakfastBuffet from '@icons/breakfast.svg';
import Business from '@icons/businessOutline.svg';
import CarRental from '@icons/car_rental.svg';
import Casino from '@icons/casino.svg';
import BabyServices from '@icons/child_services.svg';
import DryCleaning from '@icons/dry_cleaning.svg';
import Facilities from '@icons/facilities.svg';
import Fitness from '@icons/fitness.svg';
import Game from '@icons/game.svg';
import Golfcourse from '@icons/golf.svg';
import Kids from '@icons/kids.svg';
import Meeting from '@icons/meeting.svg';
import NonSmoking from '@icons/non_smoking.svg';
import Parking from '@icons/parking.svg';
import PetsAllowed from '@icons/pet_friendly.svg';
import Restaurant from '@icons/restaurant.svg';
import RoomService from '@icons/room_service.svg';
import Safe from '@icons/safe.svg';
import Skiing from '@icons/skiing.svg';
import Spa from '@icons/spa.svg';
import SwimmingPool from '@icons/swimming_pool.svg';
import Tennis from '@icons/tennis.svg';
import TickSmallIcon from '@icons/tick_small.svg';
import ValetParking from '@icons/valet.svg';
import Wifi from '@icons/wifi.svg';

interface HotelAmenityIconsProps {
  amenityId: number;
  className?: string;
  onClick?: (amenityId: number) => void;
}

const HotelAmenityIcon: React.FC<HotelAmenityIconsProps> = ({ amenityId, className, onClick }) => {
  const icon: { [key: number]: React.FC<React.SVGAttributes<SVGElement>> } = Object.freeze({
    1: Wifi,
    2: SwimmingPool,
    3: Parking,
    4: Restaurant,
    5: Facilities,
    6: Airconditioning,
    7: NonSmoking,
    8: PetsAllowed,
    9: Safe,
    10: BabyServices,
    11: Meeting,
    12: Business,
    13: CarRental,
    14: Casino,
    15: BreakfastBuffet,
    16: AirportShuttle,
    17: Golfcourse,
    18: Spa,
    19: Fitness,
    20: Bar,
    21: Skiing,
    22: Kids,
    23: Tennis,
    24: Beach,
    25: Game,
    26: SwimmingPool,
    27: SwimmingPool,
    28: RoomService,
    29: DryCleaning,
    30: ValetParking,
  });

  const AmenityIcon = icon[amenityId];

  const handleOnHotelAmenityIconClick = (amenityId: number) => {
    if (onClick) {
      onClick(amenityId);
    }
  };

  return AmenityIcon ? (
    <AmenityIcon className={className} onClick={() => handleOnHotelAmenityIconClick(amenityId)} />
  ) : (
    <TickSmallIcon className={className} onClick={() => handleOnHotelAmenityIconClick(amenityId)} />
  );
};

export default HotelAmenityIcon;
